var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamBaedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30542 8.11111C9.30542 8.93623 9.6332 9.72755 10.2166 10.311C10.8001 10.8944 11.5914 11.2222 12.4165 11.2222C13.2416 11.2222 14.033 10.8944 14.6164 10.311C15.1999 9.72755 15.5276 8.93623 15.5276 8.11111C15.5276 7.28599 15.1999 6.49467 14.6164 5.91122C14.033 5.32778 13.2416 5 12.4165 5C11.5914 5 10.8001 5.32778 10.2166 5.91122C9.6332 6.49467 9.30542 7.28599 9.30542 8.11111Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74988 19.0006V17.4451C7.74988 16.62 8.07765 15.8287 8.6611 15.2452C9.24455 14.6618 10.0359 14.334 10.861 14.334H13.9721C14.7972 14.334 15.5885 14.6618 16.172 15.2452C16.7554 15.8287 17.0832 16.62 17.0832 17.4451V19.0006",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8612 5.10156C18.5304 5.27291 19.1236 5.66211 19.5471 6.2078C19.9707 6.7535 20.2006 7.42465 20.2006 8.11545C20.2006 8.80625 19.9707 9.4774 19.5471 10.0231C19.1236 10.5688 18.5304 10.958 17.8612 11.1293",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 19.0012V17.4456C21.746 16.759 21.515 16.0929 21.0929 15.5513C20.6709 15.0096 20.0815 14.6228 19.4166 14.4512",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13867 5.10156C6.46946 5.27291 5.87631 5.66211 5.45273 6.2078C5.02915 6.7535 4.79924 7.42465 4.79924 8.11545C4.79924 8.80625 5.02915 9.4774 5.45273 10.0231C5.87631 10.5688 6.46946 10.958 7.13867 11.1293",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25004 19.0012V17.4456C3.25399 16.759 3.485 16.0929 3.90706 15.5513C4.32911 15.0096 4.91851 14.6228 5.58337 14.4512",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBaedIc);
export default __webpack_public_path__ + "static/media/team_baed_ic.9c9375fdb4c68bb47cf2cf536646f535.svg";
export { ForwardRef as ReactComponent };